/* eslint-disable no-redeclare */
import { z } from 'zod';

import { SurveyAnswers } from './medicare-advantage-survey-answers';
import { PlateName } from './plate-name';

export const PlateSubmission = z.object({
  plateName: PlateName,
  surveyAnswers: SurveyAnswers.partial(),
});

export type PlateSubmission = z.infer<typeof PlateSubmission>;

export const PlateTransition = z.object({
  nextPlate: PlateName,
});

export type PlateTransition = z.infer<typeof PlateTransition>;
